// extracted by mini-css-extract-plugin
export default {"container":"UiLabel_container_ZHd1k","icon":"UiLabel_icon_AjiE3","label":"UiLabel_label_AzpqK"};